/* SVG thumbnails for portfolio cards. */

export const SleepySlothThumb = ({ className = "" }) => (
  <svg
    viewBox="0 0 320 200"
    className={className}
    role="img"
    aria-label="Sleepy Sloth concept thumbnail"
  >
    <defs>
      <linearGradient id="ss-bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#2A1B14" />
        <stop offset="100%" stopColor="#1A1C20" />
      </linearGradient>
    </defs>
    <rect width="320" height="200" fill="url(#ss-bg)" />
    {/* Moon */}
    <circle cx="250" cy="55" r="22" fill="#FFEEE6" opacity="0.92" />
    <circle cx="244" cy="50" r="6" fill="#1A1C20" opacity="0.18" />
    <circle cx="258" cy="60" r="4" fill="#1A1C20" opacity="0.18" />
    {/* Tree branch */}
    <path
      d="M0 110 C80 120, 160 100, 320 130"
      stroke="#5B3A22"
      strokeWidth="10"
      fill="none"
      strokeLinecap="round"
    />
    {/* Sloth body */}
    <ellipse cx="170" cy="118" rx="42" ry="26" fill="#A0805F" />
    {/* Sloth head */}
    <circle cx="205" cy="110" r="22" fill="#B89472" />
    {/* Face */}
    <path d="M196 112 a4 1.5 0 1 0 -0.1 0" fill="#1A1C20" />
    <path d="M214 112 a4 1.5 0 1 0 -0.1 0" fill="#1A1C20" />
    <path
      d="M199 119 q6 5 12 0"
      stroke="#1A1C20"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
    />
    {/* Arm hanging */}
    <path
      d="M138 116 q-12 18 -4 36"
      stroke="#A0805F"
      strokeWidth="14"
      fill="none"
      strokeLinecap="round"
    />
    {/* Z's */}
    <text x="222" y="86" fill="#F35A1F" fontFamily="Space Grotesk" fontSize="18" fontWeight="700">z</text>
    <text x="234" y="74" fill="#F35A1F" fontFamily="Space Grotesk" fontSize="14" fontWeight="700">z</text>
    <text x="244" y="64" fill="#F35A1F" fontFamily="Space Grotesk" fontSize="10" fontWeight="700">z</text>
  </svg>
);

export const CosmicCatThumb = ({ className = "" }) => (
  <svg
    viewBox="0 0 320 200"
    className={className}
    role="img"
    aria-label="Cosmic Cat concept thumbnail"
  >
    <defs>
      <radialGradient id="cc-bg" cx="50%" cy="50%" r="70%">
        <stop offset="0%" stopColor="#2A1F35" />
        <stop offset="100%" stopColor="#0F0F18" />
      </radialGradient>
    </defs>
    <rect width="320" height="200" fill="url(#cc-bg)" />
    {/* Stars */}
    {[
      [30, 30, 1.5],
      [70, 60, 1],
      [110, 25, 1.2],
      [260, 40, 1.6],
      [290, 90, 1],
      [50, 150, 1.2],
      [280, 160, 1.4],
      [200, 30, 1],
    ].map(([x, y, r], i) => (
      <circle key={i} cx={x} cy={y} r={r} fill="#FBFAF8" opacity="0.85" />
    ))}
    {/* Planet */}
    <circle cx="260" cy="150" r="24" fill="#F35A1F" />
    <ellipse cx="260" cy="150" rx="34" ry="6" fill="none" stroke="#FFEEE6" strokeWidth="2" opacity="0.6" />
    {/* Rocket cat body */}
    <g transform="translate(120,90) rotate(-12)">
      {/* Helmet */}
      <circle cx="40" cy="30" r="30" fill="#1A1C20" stroke="#FBFAF8" strokeWidth="3" />
      <circle cx="40" cy="30" r="24" fill="#FFEEE6" />
      {/* Cat face */}
      <circle cx="40" cy="32" r="18" fill="#F2C28C" />
      <path d="M28 18 L34 28 L22 28 Z" fill="#F2C28C" />
      <path d="M52 18 L58 28 L46 28 Z" fill="#F2C28C" />
      <circle cx="33" cy="32" r="2" fill="#1A1C20" />
      <circle cx="47" cy="32" r="2" fill="#1A1C20" />
      <path d="M37 38 q3 3 6 0" stroke="#1A1C20" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      {/* Body suit */}
      <rect x="22" y="58" width="36" height="36" rx="8" fill="#FBFAF8" stroke="#1A1C20" strokeWidth="3" />
      <circle cx="40" cy="76" r="5" fill="#F35A1F" />
    </g>
  </svg>
);

export const PixelPicnicThumb = ({ className = "" }) => (
  <svg
    viewBox="0 0 320 200"
    className={className}
    role="img"
    aria-label="Pixel Picnic concept thumbnail"
  >
    <defs>
      <linearGradient id="pp-bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#3F2D1B" />
        <stop offset="100%" stopColor="#1A1C20" />
      </linearGradient>
      <pattern id="checker" width="20" height="20" patternUnits="userSpaceOnUse">
        <rect width="20" height="20" fill="#F35A1F" />
        <rect width="10" height="10" fill="#FFEEE6" />
        <rect x="10" y="10" width="10" height="10" fill="#FFEEE6" />
      </pattern>
    </defs>
    <rect width="320" height="200" fill="url(#pp-bg)" />
    {/* Picnic blanket */}
    <g transform="translate(40,120) rotate(-6)">
      <rect width="240" height="80" rx="6" fill="url(#checker)" />
    </g>
    {/* Basket */}
    <g transform="translate(70,80)">
      <rect x="0" y="20" width="66" height="38" rx="6" fill="#7A4A22" />
      <rect x="0" y="24" width="66" height="6" fill="#5B3A22" />
      <path d="M6 24 Q33 -4 60 24" stroke="#5B3A22" strokeWidth="4" fill="none" />
      {/* Apple */}
      <circle cx="22" cy="16" r="8" fill="#D63B2A" />
      <path d="M22 8 Q24 4 28 6" stroke="#1F9D6A" strokeWidth="2" fill="none" />
      {/* Bread */}
      <ellipse cx="44" cy="20" rx="10" ry="6" fill="#E0B978" />
    </g>
    {/* Pixel sparkles */}
    <rect x="180" y="40" width="6" height="6" fill="#FBFAF8" />
    <rect x="210" y="56" width="4" height="4" fill="#FBFAF8" />
    <rect x="244" y="30" width="6" height="6" fill="#F35A1F" />
    <rect x="258" y="60" width="4" height="4" fill="#FBFAF8" />
  </svg>
);
